export enum UtrvFilter {
  AllAnswered = 'allAnswered',
  Verified = 'verified',
  Assured = 'assured',
}

export enum SurveyFilter {
  All = 'all',
  Completed = 'completed',
}

export enum PrivacyFilter {
  All = 'all',
  Public = 'public',
}
